export const debtorSummaryData = {
    success: true,
    data: {
        claim_id: "TEST1234",

        caseStatus: {
            status1: {
                code: 421,                          // MASTER.stat1_code
                description: "Pre-Suit Review",     // *STAT1_DESC // Status table
                pScheduleAmount: 2500.00            // MASTER.p_AMOUNT
            },

            status2: {
                date: "2025-11-15",                 // MASTER.stat1_date
                description: "Follow-up scheduled", // *STAT2_DESC
                diaryCode: "RVW0111",                 // MASTER.P_DCODE
                type: "Review"                      // MASTER.P_TYPE
            },

            lastDocument: {
                code: "XDWP",                       // MASTER.ll_code8
                date: "2025-01-10",                 // MASTER.ll_date
                description: "Demand letter sent"   // *LL_DESC
            },

            paymentSummary: {
                lastPaymentAmount: 126.00           // MASTER.P_PAYMENT
            },

            sCode: {
                date: "2025-01-05",                 // *SCODE_DATE
                description: "Settlement offer"     // *SCODE_DESC
            },

            sFCode: {
                date: "2025-01-07",                 // *SFCODE_DATE
                description: "Settlement follow-up" // *SFCODE_DESC
            },

            nextPayment: {
                due: "2025-02-15",                  // *NEXT_PAYMENT
                amount: 300.00                      // *NEXT_PAY_AMT
            },

            nextDiary: {
                number: 1,                          // *NEXT_DIA01
                date: "2025-02-10",                 // *NEXT_DIA_DATE01
                description: "Call debtor for payment confirmation"
            },

            lateAmount: 25.00,                      // *P_LATE

            lastPayment: {
                date: "2025-12-22",                 // MASTER.LPAYMNT_DATE
                amount: 125.00,                     // MASTER.LPAYMENT_AMT
                total: 125.00,
                scodeTotal: 450.00                  // *P_SCD_TOT
            }
        },

        debtors: [
            {
                number: 1, // [DEBTOR.NUMBER]
                relation: "Main", // [DEBTOR.RELATION]
                name: "TEST 1/TEST",  // [DEBTOR.NAME]
                phone: "Cease & Desist", // [DEBTOR.CEASE_DESIST] if true then show "Cease & Desist" instead of phone number, otherwise show phone number
                city: "WEST UNION", // [DEBTOR.CITY]
                st: "IL" // [DEBTOR.ST]
            },
            {
                number: 2,
                relation: "Secondary",
                name: "JANE SMITH",
                phone: "(312) 555-7890",
                city: "CHICAGO",
                st: "IL"
            },
            {
                number: 3,
                relation: "Guarantor",
                name: "ROBERT MILLER",
                phone: "(773) 555-4422",
                city: "CHICAGO",
                st: "IL"
            }
        ]
    }
};



export const debtorDetailData = {
    success: true,
    data: {
        debtor_number: 1, // [DEBTOR.NUMBER]
        claim_id: "TEST1234", // [MASTER.FILENO]

        demographics: {
            relation: "Main", // [DEBTOR.RELATION]
            name: "TEST 1/TEST", // [DEBTOR.NAME]
            alias: null, // [DEBTOR.ALIAS]
            salutation: null, // [DEBTOR.SAL]
            sex: "M", // [DEBTOR.SEX]
            alias_salutation: 'Mr.', // [DEBTOR.ALIAS_SAL]
            alias_type: 'DBA', // [DEBTOR.ALIAS_DBA]
            birth_date: "1980-01-15", // [DEBTOR.BIRTH_DATE]
            death_date: null // [DEBTOR.DEATH_DATE]
        },

        identification: {
            ssn: "111-58-1234", // [DEBTOR.SSN]
            drivers_license: "IL1234567", // [DEBTOR.DL]
        },

        address: {
            street: "1111 Test STreet", // [DEBTOR.STREET]
            street2: null, // [DEBTOR.STREET2]
            city: "WEST UNION", // [DEBTOR.CITY]
            state: "IL", // [DEBTOR.ST]
            zip: "29299-2929" // [DEBTOR.ZIP]
        },

        contact_info: {
            email: "TESTEMAIL@GMAIL.com", // [DEBTOR.EMAIL]
            email_consent: "Y", // [DEBTOR.EMAIL_CONSENT]
            email_consent_date: "2024-01-15", // [DEBTOR.EMAIL_CON_DATE]
            phone: "(555) 123-4567", // [DEBTOR.PHONE]
            phone_consent: "Y", // [DEBTOR.CON_PHONE]
            phone2: null, // [DEBTOR.PHONE2]
            phone2_consent: null, // [DEBTOR.CON_PHONE2]
            mobile: "(555) 987-6543", // [DEBTOR.MOBILE_PHONE]
            mobile_consent: "Y", // [DEBTOR.CON_MOBILE]
            fax: null // [DEBTOR.FAX]
        },

        legal_flags: {
            responsible_party: "N", // [DEBTOR.RESP_PARTY]
            caption: "Y", // [DEBTOR.CAPTION]
            cease_desist: "Y" // [DEBTOR.CEASE_DESIST]
        },

        legal_dates: {
            service_date: "2024-01-10", // [DEBTOR.SERVICE_DATE]
            service_type: "Personal", // [DEBTOR.SERVICE_TYPE]
            answer_filed_date: "2025-02-10", // [DEBTOR.AF_DATE]
            dismissal_date: "2026-03-10" // [DEBTOR.DISMIS_DATE]
        },

        scores: {
            fico: 10, // [DEBTOR.FICO_SCORE]
            collectability: 120,  // [DEBTOR.COLL_SCORE]
            other: 880 // [DEBTOR.OTHER_SCORE]
        },

        miscellaneous: {
            home_page: "https://home.example.com" // [DEBTOR.HOME]
        }
    },
    metadata: {
        retrieved_at: "2024-01-30T10:00:00Z",
        data_source: "DEBTOR table",
        consent_warning: "Check consent flags before contacting"
    }
};

export const debtorDetailData2 = {
    success: true,
    data: {
        debtor_number: 2,
        claim_id: "TEST1234",

        demographics: {
            relation: "Secondary",
            name: "JANE SMITH",
            alias: null,
            salutation: "Ms.",
            sex: "F",
            alias_salutation: null,
            alias_type: null,
            birth_date: "1985-07-22",
            death_date: null
        },

        identification: {
            ssn: "XXX-XX-5678",
            drivers_license: "IL7654321",
            fico_score: 0
        },

        address: {
            street: "2222 Lake Shore Dr",
            street2: "Apt 3B",
            city: "CHICAGO",
            state: "IL",
            zip: "60611"
        },

        contact_info: {
            email: "JANE.SMITH@EXAMPLE.COM",
            email_consent: "Y",
            email_consent_date: "2024-01-18",
            phone: "(312) 555-7890",
            phone_consent: "Y",
            phone2: null,
            phone2_consent: null,
            mobile: "(312) 555-3344",
            mobile_consent: "Y",
            fax: null
        },

        legal_flags: {
            responsible_party: "N",
            caption: "N",
            cease_desist: "N"
        },

        legal_dates: {
            service_date: "2024-01-12",
            service_type: "Substitute",
            answer_filed_date: null,
            dismissal_date: null
        },

        scores: {
            fico: 0,
            collectability: 0,
            other: 640
        },

        miscellaneous: {
            home_page: null
        }
    },
    metadata: {
        retrieved_at: "2024-01-30T10:00:00Z",
        data_source: "DEBTOR table",
        consent_warning: "Check consent flags before contacting"
    }
};

export const debtorDetailData3 = {
    success: true,
    data: {
        debtor_number: 3,
        claim_id: "TEST1234",

        demographics: {
            relation: "Guarantor",
            name: "ROBERT MILLER",
            alias: null,
            salutation: "Mr.",
            sex: "M",
            alias_salutation: null,
            alias_type: null,
            birth_date: "1978-03-10",
            death_date: null
        },

        identification: {
            ssn: "XXX-XX-9012",
            drivers_license: "IL9988776",
            fico_score: 0
        },

        address: {
            street: "890 West Monroe St",
            street2: null,
            city: "CHICAGO",
            state: "IL",
            zip: "60607"
        },

        contact_info: {
            email: "ROBERT.MILLER@EXAMPLE.COM",
            email_consent: "N",
            email_consent_date: null,
            phone: "(773) 555-4422",
            phone_consent: "N",
            phone2: null,
            phone2_consent: null,
            mobile: "(773) 555-9988",
            mobile_consent: "N",
            fax: null
        },

        legal_flags: {
            responsible_party: null,
            caption: "Y",
            cease_desist: "N"
        },

        legal_dates: {
            service_date: "2024-01-15",
            service_type: "Certified Mail",
            answer_filed_date: null,
            dismissal_date: null
        },

        scores: {
            fico: 0,
            collectability: 0,
            other: 710
        },

        miscellaneous: {
            home_page: null
        }
    },
    metadata: {
        retrieved_at: "2024-01-30T10:00:00Z",
        data_source: "DEBTOR table",
        consent_warning: "Check consent flags before contacting"
    }
};
